import {collection, doc, getDocs, getFirestore} from 'firebase/firestore'
import {AddPersonnelModal} from '../AddPersonnelModal'
import {saveAs} from 'file-saver'
import {useAuth} from '../../../../modules/auth'
import ExcelJS from 'exceljs'
import {useState} from 'react'
import {showErrorToast, showSuccessToast} from 'app/components/ShowToast'
import Button from 'app/components/Button'
import ExportButton from 'app/components/ExportButton'

const PersonnelListToolbar = ({currentAuditContext}) => {
  const {currentUser} = useAuth()
  const [isOpen, setIsOpen] = useState(false)

  const exportData = async () => {
    const db = getFirestore()
    const tenantId = currentUser?.tenantId
    const tenantRef = doc(db, 'tenants', tenantId!)
    const PolicyRef = collection(tenantRef, 'employees')
    const querySnapshot = await getDocs(PolicyRef)

    const data = querySnapshot.docs
      .map((doc) => doc.data())
      .filter((data) => data.role !== 'Auditor')

    if (data.length > 0) {
      const fields = [
        {key: 'full_name', header: 'Full Name', width: 30},
        {key: 'email', header: 'Email', width: 30},
        {key: 'role', header: 'Role', width: 15},
        {key: 'group', header: 'Group', width: 20},
        {key: 'start_date', header: 'Start Date', width: 20},
        {key: 'end_date', header: 'End Date', width: 20},
        {key: 'status', header: 'Status', width: 20},
        {key: 'onboarding', header: 'Onboarding', width: 20},
        {key: 'onboardingEnded', header: 'Onboarding Completed Date', width: 30},
      ]

      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('Employees')

      worksheet.columns = fields.map((field) => ({
        header: field.header,
        key: field.key,
        width: field.width,
      }))

      const headerRow = worksheet.getRow(1)
      headerRow.font = {bold: true, color: {argb: 'FFFFFFFF'}, size: 10}
      headerRow.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {argb: 'FF000000'},
      }
      headerRow.height = 30
      headerRow.alignment = {horizontal: 'center', vertical: 'middle'}
      worksheet.views = [{state: 'frozen', ySplit: 1}]

      data.forEach((row) => {
        const rowData = fields.reduce((acc, field) => {
          let value = row[field.key] || row[field.key.toLowerCase()] || ''

          if (field.key === 'onboarding') {
            if (value === '') {
              value = 'Pending'
            }
            acc[field.key] = value
          } else if (field.key === 'status') {
            value = row.end_date ? 'Inactive' : 'Active'
            acc[field.key] = value
          } else {
            acc[field.key] = value
          }

          return acc
        }, {})

        const addedRow = worksheet.addRow(rowData)
        addedRow.height = 20
        addedRow.font = {size: 10}

        const onboardingCell = addedRow.getCell('onboarding')
        if (onboardingCell.value === 'Completed') {
          onboardingCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'D9EAD3'},
          }
        } else if (onboardingCell.value === 'Pending') {
          onboardingCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'FFF2CC'},
          }
        } else {
          onboardingCell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: {argb: 'F4CCCC'},
          }
        }

        if (row['end_date']) {
          addedRow.eachCell((cell) => {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: {argb: 'F4CCCC'},
            }
          })
        }
      })

      const buffer = await workbook.xlsx.writeBuffer()
      const excelBlob = new Blob([buffer], {type: 'application/octet-stream'})
      saveAs(excelBlob, 'employees.xlsx')
      showSuccessToast({message: 'Employees data exported successfully'})
    } else {
      showErrorToast({message: 'No data to export'})
    }
  }

  const toggleDrawer = () => {
    setIsOpen(!isOpen)
  }

  const closeDrawer = () => {
    setIsOpen(false)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      {(currentUser?.role !== 'Auditor' && !currentAuditContext) && (
      <ExportButton className='me-4' onClick={exportData} />
      )}
      <AddPersonnelModal isOpen={isOpen} onClose={closeDrawer} />
      {(currentUser?.role !== 'Auditor' && !currentAuditContext) && (
        <Button btnType='primary' onClick={toggleDrawer}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            stroke-width='2'
            stroke-linecap='round'
            stroke-linejoin='round'
            className='icon icon-tabler icons-tabler-outline icon-tabler-plus me-2'
          >
            <path stroke='none' d='M0 0h24v24H0z' fill='none' />
            <path d='M12 5l0 14' />
            <path d='M5 12l14 0' />
          </svg>
          Add Employee
        </Button>
      )}
    </div>
  )
}

export {PersonnelListToolbar}
